export enum PaymentMethodEnum {
  MP = 2,
  TRANSFERENCIA_DEPOSITO = 3,
  PAGO_GAMER = 21,
  GETNET = 28,
}
